import { useNavigate } from 'react-router-dom';
import { s } from './Menu.styles';
import { isLogin } from '../../../utils/auth';
import styled from 'styled-components';
import ServiceList from './ServiceList';
import { useEffect, useState } from 'react';
import UserService from '../../../service/User';
import MembershipBadge from '../../components/membership/MembershipBadge';
import { info } from 'console';
interface MenuProps {
  setOpenMenu: (openMenu: boolean) => void;
  page?: string;
}

interface UserInfo {
  plan_grade: string | undefined;
  plan_start: string | undefined;
  plan_end: string | undefined;
}

const Menu = ({ setOpenMenu, page }: MenuProps) => {
  const navigate = useNavigate();
  const [data, setData] = useState<UserInfo>();

  const getInfo = async () => {
    try {
      if (!isLogin()) return;
      const res = await UserService.userInfo();
      setData(res.data);
    } catch (error) {
      console.error('userInfo 함수에서 에러 발생:', error);
    }
  };

  useEffect(() => {
    getInfo();
  }, []);

  useEffect(() => {
    // 메뉴가 열리면 스크롤 방지
    document.body.style.overflow = 'hidden';

    return () => {
      // 메뉴가 닫힐 때 원래 상태로 복구
      document.body.style.overflow = 'auto';
    };
  }, []);

  const membershipLabelMap: Record<string, string> = {
    P: 'Premium',
    S: 'Standard',
    T: 'Promotion',
  };

  const label = data?.plan_grade
    ? (membershipLabelMap[data.plan_grade] ?? 'Free')
    : 'Free';

  const renderSignUpArea = () => {
    if (isLogin()) {
      return (
        <s.AfterLoginBox>
          <s.UserNameBox>
            <s.UserName>
              <span style={{ color: '#008aff' }}>
                {localStorage.getItem('userName')}
              </span>
              <span>님 환영합니다!</span>
            </s.UserName>
            <s.MyPageButtonBox
              onClick={() => {
                navigate('/mypage');
                sessionStorage.setItem('mypageTab', 'interest');
                setOpenMenu(false);
              }}
            >
              <span>마이페이지</span>
              <img src="/assets/images/arrow/arrow-right-gray.svg" alt="" />
            </s.MyPageButtonBox>
          </s.UserNameBox>
          <MembershipBadge data={data} page="menu" />
          <MyPageButtonBox>
            <MyPageButton
              onClick={() => {
                navigate('/mypage');
                sessionStorage.setItem('mypageTab', 'interest');
              }}
            >
              <span>내 관심물건</span>
            </MyPageButton>
            <MyPageButton
              onClick={() => {
                navigate('/mypage');
                sessionStorage.setItem('mypageTab', 'recent');
              }}
            >
              <span>최근 열람 물건</span>
            </MyPageButton>
            <MyPageButton
              onClick={() => {
                navigate('/mypage');
                sessionStorage.setItem('mypageTab', 'myinfo');
              }}
            >
              <span>내 정보 수정</span>
            </MyPageButton>
          </MyPageButtonBox>
        </s.AfterLoginBox>
      );
    } else {
      return (
        <s.BeforeLoginBox>
          <div>손쉽게 시작하는 현명한 투자!</div>
          <s.LoginButton
            onClick={() => {
              navigate('/login');
            }}
          >
            땅집고옥션 로그인
          </s.LoginButton>
          <s.FindIdBox>
            <FindBox>
              <div
                onClick={() => {
                  navigate('/find', { state: { type: 'id' } });
                }}
              >
                아이디&nbsp;
              </div>
              <div> ∙&nbsp;</div>
              <div
                onClick={() => {
                  navigate('/find', {
                    state: { type: 'password' },
                  });
                }}
              >
                비밀번호 찾기
              </div>
            </FindBox>
            <div
              style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}
              onClick={() => {
                // 회원가입 절차 페이지 없어서 일단 주석처리
                navigate('/login');
              }}
            >
              회원가입
            </div>
          </s.FindIdBox>
        </s.BeforeLoginBox>
      );
    }
  };

  return (
    <s.Container onClick={() => setOpenMenu(false)}>
      <s.Inner onClick={(e) => e.stopPropagation()}>
        <s.Top>
          <img
            src="/assets/images/logo/zipgoai_logo_mobile_header.svg"
            alt=""
            onClick={() => {
              page === 'main' ? setOpenMenu(false) : navigate('/');
            }}
          />
          <img
            src="/assets/images/close/menu-close.svg"
            alt=""
            onClick={() => {
              setOpenMenu(false);
            }}
            style={{ width: '40px', height: '40px' }}
          />
        </s.Top>
        <s.SignUpBox>{renderSignUpArea()}</s.SignUpBox>
        <ServiceList page={page} setOpenMenu={setOpenMenu} />
      </s.Inner>
    </s.Container>
  );
};

export default Menu;

const FindBox = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
`;

const MyPageButtonBox = styled.div`
  width: 100%;
  height: 43px;
  display: flex;
  background-color: #fafafa;
  border-radius: 8px;
  overflow: hidden;
`;

const MyPageButton = styled.div`
  width: 100%;
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: Spoqa Han Sans Neo;
  font-size: 12px;
  font-weight: 500;
  color: #616161;
  cursor: pointer;
  position: relative;
  height: 43px;

  &::after {
    content: '';
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 1px;
    height: 24px;
    background-color: rgba(112, 115, 124, 0.22);
  }

  &:last-child::after {
    display: none;
  }
`;
